import { TableColumn } from '@ansys-internal/awf-angular/contributions';
import {
  AWCTableCell,
  TableCellAlign,
  TableCellTypes,
} from '@ansys-internal/awc-angular/tables';
import { AWFTableColumn } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../contributions.enum';
import { DriveCycleTableType } from '../../../shared/types/drive-cycle-table.type';

@AWFTableColumn({
  id: ContributionsEnum.DRIVE_CYCLE_TABLE_NAME_COLUMN,
  priority: 50,
})
export class DriveCycleTableNameColumn implements TableColumn {
  id: string = ContributionsEnum.DRIVE_CYCLE_TABLE_NAME_COLUMN;
  priority: number = 50;
  align: TableCellAlign = TableCellAlign.LEFT;
  header: string = 'Name';
  type: TableCellTypes = TableCellTypes.TEXT;

  public async render(data: DriveCycleTableType): Promise<AWCTableCell> {
    return { value: data.name };
  }
}
